/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
import { Injectable, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

@Injectable()
export class PasswordConfirmationValidator implements Validator {
  @Input() passwordFormName = '';
  @Input() passwordConfirmationFormName = '';

  validate(control: AbstractControl): { [key: string]: any } | null {
    const formGroup = control as UntypedFormGroup;
    return passwordConfirmationValidation(this.passwordFormName, this.passwordConfirmationFormName)(formGroup);
  }
}

export const passwordConfirmationValidation = (
  passwordFormName = '',
  passwordConfirmationFormName = ''
): ValidatorFn => {
  return (control: AbstractControl) => {
    const formGroup = control as UntypedFormGroup;
    let errors: ErrorModel | null = null;
    const passwordFormControl = formGroup.controls[passwordFormName];
    const passwordConfirmationFormControl: AbstractControl = formGroup.controls[passwordConfirmationFormName];

    if (passwordFormControl.value == null && passwordConfirmationFormControl.value == null) {
      return null;
    }

    if (passwordFormControl.value != passwordConfirmationFormControl.value) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: 'passwordConfirmationMatchError',
      };
    }

    passwordConfirmationFormControl.setErrors(errors);

    return errors ? errors : null;
  };
};
